export const ADD_MESSAGE = 'ADD_MESSAGE';
export const RESET_AI_STATE = 'RESET_AI_STATE';
export const SET_MESSAGE_STATUS = 'SET_MESSAGE_STATUS';
export const APPEND_TO_MESSAGE = 'APPEND_TO_MESSAGE';
